import React from 'react'
import { Value } from './index.style'

const ValueComponent = option => {
  return <Value>{option.value.name}</Value>
}

export default ValueComponent



// WEBPACK FOOTER //
// ./src/components/PollForm/VerticalTargeting/ValueRenderer.js